import { HandleApiError } from "sr/helpers/functions/HandleApiError";
import ApiResponse from "sr/models/ApiResponse";
import { del } from "sr/utils/axios";

type DeleteUserPayload = {
  reason: string;
};

export const deleteUser = async (payload: DeleteUserPayload) => {
  try {
    return await del<ApiResponse<[]>>("/user/delete", payload).then((res) => {
      if (res?.success === true) {
        return res;
      }

      return null;
    });
  } catch (e) {
    HandleApiError(e);
  }
};
